import { FC, useContext } from 'react'
import cx from 'classnames'
import { WishlistContext } from '../../../../contexts/wishlist'
import styles from './FavoriteBtn.module.scss'
import Like from './like.svg'

interface FavoriteBtn {
  id: string
  className?: string
}
const FavoriteBtn: FC<FavoriteBtn> = ({ id, className }) => {
  const { inited, wishlist, addToWishlist, removeFromWishlist } =
    useContext(WishlistContext)
  const inWishlist = wishlist[id]

  if (!inited) {
    return null
  }

  return (
    <button
      className={cx(styles.btn, className, inWishlist && styles.inWishlist)}
      type="button"
      title={inWishlist ? 'Удалить из избранного' : 'Добавить в избранное'}
      onClick={() => {
        if (inWishlist) {
          removeFromWishlist(id)
        } else {
          addToWishlist(id)
        }
      }}
    >
      <Like />
    </button>
  )
}

export default FavoriteBtn
